import Skeleton from 'react-loading-skeleton'

const CartFeedbackProductCardSkeleton = () => {
  return (
    <div className="flex flex-col mb-12 sm:mb-0 sm:pb-12 max-h-[99px] sm:max-h-[300px] w-full overflow-hidden">
      <Skeleton height={90} width="100%" />
      <Skeleton height={90} width="100%" />
      <Skeleton height={40} width="100%" />
    </div>
  )
}

export default CartFeedbackProductCardSkeleton
